import { Helpers } from '../core/src/helpers';

export const fetchBV = (sku)  => {
	const { $BV } = window;
    if( sku && $BV ) {
        const transformedSku = Helpers.BVTransformSKU(sku);
        $BV.ui('rr', 'show_reviews', {productId: transformedSku});
    }
}
